
import axios from "axios";
import React, { useState } from 'react';
import {Button, Tooltip} from '@material-ui/core';


export default function CopyAsyncItemsFieldToClipboardButton({ url, children }) {

  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 800);
  };

  const handleClick = () => {
    setLoading(true);
    axios.get(url).then(res => {
      if (res.data) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(
            res.data.join('\n')
          );
          handleCopied();
        }
      }
    }).finally(() => {
      setLoading(false);
    })
  }

  return (
      <Tooltip
        title="Скопировано"
        disableFocusListener
        disableHoverListener
        disableTouchListener
        open={copied}
      >
        <Button onClick={handleClick} disabled={loading}>
          {children}
        </Button>
      </Tooltip>
    )
}
